import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ofType } from 'redux-observable';
import { EMPTY, Subject, merge } from 'rxjs';
import { mergeMap, take, switchMap } from 'rxjs/operators';

import { NotificationService, NOTIFICATION_TYPE_ERROR, NOTIFICATION_TYPE_SUCCESS } from 'ui-components/services/notification-service';

import * as Actions from '../eod/shipments.eod.actions';
import { startCloseEODShipments } from './shipments.eod.observables';
import { closeShipmentsModalMessages } from '../../../shipping/end-of-day/open-shipments/messages';
import { printEndOfDayForms } from '../../printing/print.actions';
import { printFormsPathname } from '../../../routes/constants';
import { LogService } from '../../../services/log-service';

export const closeEODShipments = (action$, _, { push }) => {
  return action$.pipe(
    ofType(Actions.CLOSE_EOD_SHIPMENTS),
    switchMap(({ payload, onError, onSuccess }) => {
      return merge(
        startCloseEODShipments({
          action$,
          payload,
          onSuccess,
          onError,
        }),
        action$.pipe(
          ofType(Actions.CLOSE_EOD_SHIPMENTS_SUCCESS),
          take(1),
          mergeMap((response) => {
            const { pusherData, messageGuid } = response;
            const hasErrors = pusherData.errors?.length;
            if (hasErrors) {
              LogService.logInfo('Carrier came back with errors closing EOD Shipments', { errors: pusherData.errors, messageGuid });
              NotificationService.showNotification({
                onClick: () => push(printFormsPathname(messageGuid)),
                title: <FormattedMessage {...closeShipmentsModalMessages.receivedPrintFormsErrorTitle} />,
                notificationType: NOTIFICATION_TYPE_ERROR,
                content: <FormattedMessage {...closeShipmentsModalMessages.receivedPrintFormsErrorMessage} />,
              });
              return EMPTY;
            }

            const scanFormData = pusherData.forms.map(({ SCANFormId }) => SCANFormId);
            const onClick$ = new Subject().pipe(take(1));
            NotificationService.showNotification({
              onClick: () => onClick$.next(printEndOfDayForms(scanFormData)),
              title: <FormattedMessage {...closeShipmentsModalMessages.receivedPrintFormsSuccessTitle} />,
              notificationType: NOTIFICATION_TYPE_SUCCESS,
              content: <FormattedMessage {...closeShipmentsModalMessages.receivedPrintFormsSuccessMessage} />,
            });
            return onClick$;
          }),
        ),
      );
    }),
  );
};
